import type { Category } from '../api';

interface Props {
  categories: Category[];
  selected: string;
  onSelect: (id: string) => void;
}

export function CategorySelector({ categories, selected, onSelect }: Props) {
  const overall = categories.find((c) => c.id === 'overall');
  const byName = (a: Category, b: Category) => a.name.localeCompare(b.name);
  const dI = categories.filter((c) => c.division === 'D-I').sort(byName);
  const dII = categories.filter((c) => c.division === 'D-II').sort(byName);
  const dIII = categories.filter((c) => c.division === 'D-III').sort(byName);
  const naia = categories.filter((c) => c.division === 'NAIA').sort(byName);
  const njcaa = categories.filter((c) => c.division === 'NJCAA').sort(byName);
  const other = categories.filter((c) => c.division === 'OTHER').sort(byName);
  const conferenceSelected = selected !== 'overall';

  return (
    <div className="cat-selector">
      {overall && (
        <button
          className={`cat-chip${selected === 'overall' ? ' is-active' : ''}`}
          onClick={() => onSelect('overall')}
        >
          🏆 Overall
        </button>
      )}
      <select
        className={`cat-select${conferenceSelected ? ' is-active' : ''}`}
        aria-label="Filter by conference"
        value={conferenceSelected ? selected : ''}
        onChange={(e) => onSelect(e.target.value || 'overall')}
      >
        <option value="">Filter by conference…</option>
        <optgroup label="Division I">
          {dI.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name}
            </option>
          ))}
        </optgroup>
        <optgroup label="Division II">
          {dII.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name}
            </option>
          ))}
        </optgroup>
        {dIII.length > 0 && (
          <optgroup label="Division III (Non-NCAA scholarship)">
            {dIII.map((c) => (
              <option key={c.id} value={c.id}>
                {c.name}
              </option>
            ))}
          </optgroup>
        )}
        {naia.length > 0 && (
          <optgroup label="NAIA">
            {naia.map((c) => (
              <option key={c.id} value={c.id}>
                {c.name}
              </option>
            ))}
          </optgroup>
        )}
        {njcaa.length > 0 && (
          <optgroup label="NJCAA (Junior College)">
            {njcaa.map((c) => (
              <option key={c.id} value={c.id}>
                {c.name}
              </option>
            ))}
          </optgroup>
        )}
        {other.length > 0 && (
          <optgroup label="Other">
            {other.map((c) => (
              <option key={c.id} value={c.id}>
                {c.name}
              </option>
            ))}
          </optgroup>
        )}
      </select>
    </div>
  );
}
